import { c as _c } from "react/compiler-runtime";
import type { FormWizardStepFromQuery } from "@/lib/types";
import { getI18nString } from "@/lib/utils";
import { cn } from "@repo/ui/utils";
export interface WizardStepIndicatorProps {
  steps: FormWizardStepFromQuery[];
  currentStep: number;
  locale: string;
}

/**
 * Horizontal segmented progress indicator matching the Figma form wizard
 * pattern: one thin bar per step, first N filled blue, rest pale gray, with
 * a "Step X of Y" label underneath.
 */
export const WizardStepIndicator = t0 => {
  const $ = _c(20);
  const {
    steps,
    currentStep,
    locale
  } = t0;
  const total = steps.length;
  const stepNumber = currentStep + 1;
  const t1 = steps[currentStep]?.label;
  const t2 = `Step ${stepNumber}`;
  let t3;
  if ($[0] !== locale || $[1] !== t1 || $[2] !== t2) {
    t3 = getI18nString(t1, t2, locale);
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const currentLabel = t3;
  let t4;
  if ($[4] !== currentStep || $[5] !== steps) {
    let t5;
    if ($[7] !== currentStep) {
      t5 = (step, index) => {
        const isCompletedOrActive = index <= currentStep;
        return <li key={step._key} className={cn("h-[2px] flex-1 rounded-full", isCompletedOrActive ? "bg-button-primary-background" : "bg-border-default")} />;
      };
      $[7] = currentStep;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = steps.map(t5);
    $[4] = currentStep;
    $[5] = steps;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ol className="flex gap-2" aria-hidden={true}>{t4}</ol>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== currentLabel) {
    t6 = <span className="sr-only">{currentLabel} — </span>;
    $[11] = currentLabel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== stepNumber || $[14] !== t6 || $[15] !== total) {
    t7 = <p className="typography-component-xs-regular text-text-secondary">{t6}Step {stepNumber} of {total}</p>;
    $[13] = stepNumber;
    $[14] = t6;
    $[15] = total;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <nav aria-label="Form wizard progress" data-testid="wizard-step-indicator" className="flex flex-col gap-2">{t5}{t7}</nav>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};